import { TenderMethod } from '@rygen/rygen-ui/model';

import { RateQuote } from '../rate/RateQuote';
import { TenderRequest } from '../tender/TenderRequest';

import { WaterfallTenderRateQuoteFailedReason } from './WaterfallTenderRateQuoteFailedReason';
import { WaterfallTenderRateQuoteStatus } from './WaterfallTenderRateQuoteStatus';

export class WaterfallTenderRateQuote {
  id: number;
  rateQuote: RateQuote;
  status: WaterfallTenderRateQuoteStatus;
  failedReason: WaterfallTenderRateQuoteFailedReason;
  tenderMethod: TenderMethod;
  tenderRequest?: TenderRequest;
  sequenceNumber: number;

  constructor(opts: WaterfallTenderRateQuote) {
    this.id = opts.id;
    this.rateQuote = new RateQuote(opts.rateQuote);
    if (typeof opts?.status === 'string') {
      this.status = WaterfallTenderRateQuoteStatus[opts.status];
    } else {
      this.status = opts.status;
    }
    if (typeof opts?.failedReason === 'string') {
      this.failedReason =
        WaterfallTenderRateQuoteFailedReason[opts.failedReason];
    } else {
      this.failedReason = opts.failedReason;
    }
    if (typeof opts?.tenderMethod === 'string') {
      this.tenderMethod = TenderMethod[opts.tenderMethod];
    } else {
      this.tenderMethod = opts.tenderMethod;
    }
    if (opts?.tenderRequest != null) {
      this.tenderRequest = new TenderRequest(opts.tenderRequest);
    }
    this.sequenceNumber = opts.sequenceNumber;
  }

  get isPending(): boolean {
    return this.status === WaterfallTenderRateQuoteStatus.PENDING;
  }

  get isTendered(): boolean {
    return this.status === WaterfallTenderRateQuoteStatus.TENDERED;
  }

  get isTenderFailed(): boolean {
    return this.status === WaterfallTenderRateQuoteStatus.FAILED_TO_TENDER;
  }

  get isCompleted(): boolean {
    return this.status === WaterfallTenderRateQuoteStatus.COMPLETED;
  }
}
